import React from 'react'
import classnames from 'classnames'

import * as S from './styles'

const Input = React.forwardRef((props, ref) => (
  <S.LoginInput
    className={classnames(
      props.status ? 'active' : '',
      props.borderDanger ? 'borderDanger' : '',
      props.disabled
    )}
  >
    <label htmlFor={props.id}>{props.label}</label>
    <input
      type={props.type}
      id={props.id}
      name={props.name}
      ref={ref}
      onChange={props.onChange}
      onClick={props.onClick}
      onSelect={props.onClick}
      value={props.value}
      data-cy={props.dataCy}
    />
    {props.children}
  </S.LoginInput>
))

export default Input
